import { erpAxios } from '.';

const existingReplacementLoans = async (broj) => {
  const { data } = await erpAxios.get(`/loanReleaseAnalytics/existingReplacementLoans/${broj}`);
  return data;
};

export default existingReplacementLoans;
